import React from "react";
import { cn } from "~/utils";

const FancyLink = ({
  children,
  className,
  onClick,
  variant = "blue",
  ...props
}) => {
  const handleClick = (e) => {
    if (typeof onClick === "function") {
      onClick(e);
    }
  };

  const variantStyle =
    {
      amber: "border-amber-200 bg-amber-100 text-amber-600 hover:border-amber-300",
      blue: "border-blue-100 bg-blue-50 text-blue-500 hover:border-blue-200",
      gray: "border-gray-200 bg-gray-100 text-gray-600 hover:border-gray-300",
      rose: "border-rose-100 bg-rose-50 text-rose-500 hover:border-rose-200",
      teal: "border-teal-100 bg-teal-50 text-teal-500 hover:border-teal-200",
      violet:
        "border-violet-100 bg-violet-50 text-violet-500 hover:border-violet-200",
    }[variant] ?? "";

  return (
    <a
      className={cn(
        "group flex cursor-pointer select-none items-center justify-center gap-1.5 rounded-md border border-blue-100 bg-blue-50 bg-opacity-40 p-2 text-sm text-blue-500 underline-offset-2 transition-colors hover:border-blue-200 hover:bg-opacity-90 hover:underline",
        variantStyle,
        className,
      )}
      onClick={handleClick}
      {...props}
    >
      {children}
    </a>
  );
};

export default FancyLink;
